import React, { Component } from 'react'
import { connect } from 'react-redux'

// Components
import TrainingListing from './training/TrainingListing'
import ReviewsListing from './reviews/ReviewsListing'

import { userIsReviewer } from '../../utils/reviewerHelpers'

class HomeListingsPano extends Component {
	render() {
		return (
			<div className='section section-home flex'>
				<TrainingListing />
				{userIsReviewer(this.props.reviewer.user) && <ReviewsListing />}
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		reviewer: state.user.reviewer,
	}
}

export default connect(mapStateToProps)(HomeListingsPano)



// WEBPACK FOOTER //
// ./src/components/home/HomeListingsPano.js